// Catch-all route: matches every URL except those handled by dedicated Vike pages (e.g. /ssr-test).
// This renders the existing SPA shell client-side only.
export default '/*'
